"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IP_AUTO_APPROVED_LABEL = exports.IP_AUTO_APPROVED_SOURCE_MODULE = exports.IP_OLD_ADMISSION_OPERATOR_EMAIL = exports.IP_OLD_ADMISSION_DISCHARGED_ACTION = exports.IP_ADMISSION_BLOCKING_STATUSES = void 0;
exports.ipStayBlocksNewAdmission = ipStayBlocksNewAdmission;
exports.isIpOldAdmissionOperator = isIpOldAdmissionOperator;
exports.isIpAutoApproved = isIpAutoApproved;
/**
 * WHICH STAYS STOP THE SAME PATIENT BEING ADMITTED AGAIN.
 *
 * Desk, 2026-10-09 (IP Registration, patient already admitted): "Discharge Old
 * Admission button required... when user clicks this... Bill number will become
 * Advised Discharged state. new admission will consider for this OP."
 *
 * Until now ANY running stay refused the second admission, and the only way to
 * clear it was to leave the registration screen, find the bill in IP Billing,
 * advise its discharge there and come back. The advice is the clinical statement
 * that the stay is over — the ledger is frozen in the same update and nothing more
 * can be charged to that bill — so a stay in that state is no longer a reason to
 * refuse the next one. Its balance is still collected against ITS bill number;
 * the new stay gets a bill number of its own (the IP number stays the patient's).
 *
 *   ADMITTED, PENDING_CLEARANCE   still taking charges      -> BLOCK
 *   DISCHARGE_ADVISED             frozen, waiting on balance -> does not block
 *   BILL_FINALISED                settled, about to close    -> does not block
 *
 * ONE LIST, read by the server (`IpAdmissionRepository.findOpenByPatient`, which
 * refuses) and by the registration screen (which decides whether to offer the
 * Discharge Old Admission button instead of the form) — so the two cannot
 * disagree about the same patient.
 */
exports.IP_ADMISSION_BLOCKING_STATUSES = ['ADMITTED', 'PENDING_CLEARANCE'];
/**
 * True when a stay in `status` must be discharged (advised) before the patient is admitted again.
 *
 * A MISSING status answers TRUE: this is asked of a stay already known to be
 * running, and not knowing what state it is in is no reason to let a second one
 * open. The server asks the same question with the real column and has the last word.
 */
function ipStayBlocksNewAdmission(status) {
    if (status === null || status === undefined || status === '')
        return true;
    return exports.IP_ADMISSION_BLOCKING_STATUSES.includes(status);
}
/**
 * The `audit_logs.action` written when a stay is discharged through "Discharge Old Admission".
 *
 * ONE NAME, written by `IpAdmissionApplicationService.dischargeOldAdmission` and read by the
 * "Unsettled IP" report — the tab in IP Billing that lists these bills with who, when and why until
 * they are settled. Two spellings of it would be a tab that is quietly empty.
 */
exports.IP_OLD_ADMISSION_DISCHARGED_ACTION = 'IP_OLD_ADMISSION_DISCHARGED';
/**
 * THE ONLY ACCOUNT THAT MAY USE "DISCHARGE OLD ADMISSION" (owner, 2026-10-09: "this button required only user
 * csihmhdevelopment@gmail.com no other user should not be visible this button").
 *
 * An ACCOUNT check on purpose, like the record-correction one (`record-correction-operator.ts` in the frontend): every role
 * that admits patients already holds the permission the route asks for, so no permission edit could single one login out.
 * Read by the SERVER (which refuses anyone else, because a button that is merely hidden still leaves the route open to a
 * second tab or any client) and by the screen (which does not draw the button for anyone else). Matched case-insensitively -
 * the address is the same mailbox however it was typed.
 */
exports.IP_OLD_ADMISSION_OPERATOR_EMAIL = 'csihmhdevelopment@gmail.com';
function isIpOldAdmissionOperator(email) {
    return typeof email === 'string' && email.trim().toLowerCase() === exports.IP_OLD_ADMISSION_OPERATOR_EMAIL;
}
/**
 * THE SOURCE MODULE OF A CHARGE LINE THE SYSTEM APPROVED ITSELF (owner, 2026-10-09: "this should be auto approved by system..
 * it should show auto approved in approved info").
 *
 * "Discharge Old Admission" cannot stop at a bill that still has unapproved lines - the desk that clicks it is not the desk that
 * entered them - so it approves them first, through the SAME capture the billing desk's tick uses (same price resolution, same
 * ledger row). The ledger has no column for HOW a line was approved, so the line carries this value in `sourceModule` (the
 * billing desk's own is `IP_BILLING_DESK`), and every screen that shows the approver reads it and prints
 * `IP_AUTO_APPROVED_LABEL` instead of a name. `capturedBy` still records the user whose click it was.
 */
exports.IP_AUTO_APPROVED_SOURCE_MODULE = 'IP_BILLING_DESK_AUTO_APPROVED';
exports.IP_AUTO_APPROVED_LABEL = 'Auto approved';
function isIpAutoApproved(sourceModule) {
    return sourceModule === exports.IP_AUTO_APPROVED_SOURCE_MODULE;
}
//# sourceMappingURL=ip-admission-blocking.js.map